// extracted by mini-css-extract-plugin
export default {"imageRoot":"styles_imageRoot__0DGA2","root":"styles_root__7hYAM"};